import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

class ProfileImageViewer extends React.Component {
    render() {
        const { imageUrl, close } = this.props;

        return (
            <Lightbox
                reactModalStyle={{
                    overlay: {
                        zIndex: 60000,
                    },
                }}
                mainSrc={imageUrl}
                onCloseRequest={close}
                enableZoom={true}
            />
        );
    }
}

ProfileImageViewer.propTypes = {
    imageUrl: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
};

export default ProfileImageViewer;



// WEBPACK FOOTER //
// ./src/components/ProfileImageViewer.jsx